import React, { useEffect, useState } from "react";
import { useRegisterMutation } from "../../redux/api/authApi";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MetaData from "../layout/MetaData";

const Register = () => {
    const [user, setUser] = useState({
        name: "",
        email: "",
        password: "",
    });

    const { name, email, password } = user;
    const navigate = useNavigate();

    const [register, { isLoading, error, data }] = useRegisterMutation();

    const { isAuthenticated } = useSelector((state) => state.auth)

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/")
        }
        if (error) {
            toast.error(error?.data?.message)
        }
        // Some environments surface `data` after successful registration
        // Use it to keep ESLint satisfied and preserve existing UX
        if (data && !isAuthenticated) {
            // Optionally navigate or show a toast; retain current flow
            // e.g., stay on page until auth state updates
        }
    }, [error, isAuthenticated, navigate, data]);

    const submitHandler = (e) => {
        e.preventDefault();
        register({ name, email, password });
    };

    const onChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    return (
        <>
            <MetaData title={"Register"} />
            <main className="main-content">
                <div className="login-wrapper">
                    <div className="login-card shadow-lg rounded-4">
                        <form onSubmit={submitHandler}>
                            <h2 className="mb-4 text-center fw-bold text" style={{ color: '#e04f6e' }}>Register💖</h2>

                            {/* Name */}
                            <div className="mb-3">
                                <label htmlFor="name_field" className="form-label fw-semibold" style={{ color: '#e04f6e' }}>
                                    Name
                                </label>
                                <input
                                    type="text"
                                    id="name_field"
                                    className="form-control rounded-3 p-2"
                                    name="name"
                                    value={name}
                                    onChange={onChange}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>

                            {/* Email */}
                            <div className="mb-3">
                                <label htmlFor="email_field" className="form-label fw-semibold" style={{ color: '#e04f6e' }}>
                                    Email
                                </label>
                                <input
                                    type="email"
                                    id="email_field"
                                    className="form-control rounded-3 p-2"
                                    name="email"
                                    value={email}
                                    onChange={onChange}
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>

                            {/* Password */}
                            <div className="mb-3">
                                <label htmlFor="password_field" className="form-label fw-semibold"style={{ color: '#e04f6e' }}>
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="password_field"
                                    className="form-control rounded-3 p-2"
                                    name="password"
                                    value={password}
                                    onChange={onChange}
                                    placeholder="Enter your password"
                                    required
                                />
                            </div>

                            {/* Already have an account link */}
                            <div className="d-flex justify-content-end align-items-center mb-4">
                                <a href="/login" className="link-primary small">
                                    Already have an account? Login
                                </a>
                            </div>

                            {/* Button */}
                            <button
                                id="register_button"
                                type="submit"
                                className="btn w-100 py-2 fw-semibold View-btn"
                                disabled={isLoading}
                            >
                                {isLoading ? "Creating..." : "REGISTER"}
                            </button>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Register;

